'use client';

import { CustomChangeLayout } from '@/components/custom-change-layout/custom-change-layout';
import CustomDialog from '@/components/custom-dialog';
import { Input } from '@/components/ui/input';
import { Search } from 'lucide-react';
import { useTranslations } from 'next-intl';

const HeaderSearchInApp = () => {
    return (
        <CustomChangeLayout
            legacyComponent={null}
            modernComponent={<ModernHeaderSearchInApp />}
        />
    );
};

const ModernHeaderSearchInApp = () => {
    const transDef = useTranslations('System');

    return (
        <CustomDialog
            headerTitle={transDef('System_Search')}
            trigger={
                <div className='flex h-8 w-8 min-w-8 cursor-pointer items-center justify-center gap-2 rounded-full border-2 border-transparent bg-secondary text-secondary-foreground transition-colors duration-200 hover:border-primary lg:w-52 lg:justify-start lg:rounded-md lg:px-3 lg:py-2'>
                    <Search className='h-5 w-5' />
                    <p className='hidden text-sm lg:block'>
                        {transDef('System_Search')}
                    </p>
                </div>
            }
        >
            <div>
                <div className='relative'>
                    <Search className='no-ring absolute left-2.5 top-1/2 h-4 w-4 -translate-y-1/2' />
                    <Input
                        className='w-full pl-8'
                        placeholder={transDef('System_Search') + '...'}
                    />
                </div>
                <div className='min-h-96'></div>
            </div>
        </CustomDialog>
    );
};

export default HeaderSearchInApp;
